export default function ErrorPage() {
  return (
    <div id='error-page' style={{ marginTop: '10%' }}>
      <h1>Oops!</h1>
      <p>Sorry, this page does not exist.</p>
      <p>{/* <i>{error.statusText || error.message}</i> */}</p>
    </div>
  )
}
